export default "__VITE_PUBLIC_ASSET__516e4b5a__"